import React, { Dispatch, SetStateAction } from 'react'

export const PreviewTag = ({
  setIsOpenModal,
}: {
  setIsOpenModal?: Dispatch<SetStateAction<boolean>>
}) => {
  return (
    <span
      className="px-2 py-1 text-white text-[14px] bg-[#8C9DC2] rounded-[6px]  cursor-pointer font-bold"
      onClick={() => {
        if (setIsOpenModal) {
          setIsOpenModal(true)
        }
      }}
    >
      미리보기
    </span>
  )
}
